import { fromJS, Map as iMap } from 'immutable';

import * as constants from './upgrade-constants';

const initialState = iMap({
  upgradeReason: 'generic',
});

export function upgrade(state = initialState, action) {
  switch (action.type) {
    case constants.REASON:
      return state.merge(fromJS(action.payload));
    default:
      return initialState.merge(state);
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/ui/components/upgrade/upgrade-reducer.js